import { Outlet } from 'react-router-dom'

function Gallery() {
	return <Outlet />
}

export default Gallery
